import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

// ⚠️ NOTE: 'token' param ab zaroori nahi hai (same reason as DynamicTokenPostSlice)
export const dynamicTokenPatch = createAsyncThunk(
  "posts/fetchPosts",
  async ({ url, FormDataDynamic }) => {
    try {
      const formData = new FormData();
      Object.keys(FormDataDynamic).forEach((key) => {
        formData.append(key, FormDataDynamic[key]);
      });

      const response = await axiosInstance.patch(url, formData, {
        headers: {
          Accept: "*/*",
        },
      });

      return response && response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
  }
);

const dynamicTokenPatchSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dynamicTokenPatch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(dynamicTokenPatch.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(dynamicTokenPatch.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default dynamicTokenPatchSlice.reducer;